module.exports = __webpack_public_path__ + "./assets/ihouse_web_logo.png";